export function formatRating(rating) {
	return (Math.round(rating * 10) / 10).toFixed(1).replace('.', ',');
}
